import { Controller } from '@hotwired/stimulus'

// Issue #13065 (S-7) / Issue #13068 (S-9)
// 体制管理ページの「出勤」「新人」チェックボックス即時保存。
//
// Stimulus 登録名はパス由来（admin--ca--duty-rosters--show--component）。
// パラメータは `Action.params` から取得し、登録名に依存しない実装にしている。
export default class extends Controller {
  static values = {
    dutyUrl: String,
    newcomerUrl: String,
  }

  toggle (event) {
    const checkbox = event.currentTarget
    const adminUserId = event.params.adminUserId
    const kind = event.params.kind

    if (!adminUserId || !kind) return

    const url = kind === 'newcomer' ? this.newcomerUrlValue : this.dutyUrlValue
    const paramKey = kind === 'newcomer' ? 'is_ca3_trainee' : 'on_duty'

    const formData = new FormData()
    formData.append('admin_user_id', adminUserId)
    formData.append(paramKey, checkbox.checked ? 'true' : 'false')

    fetch(url, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': this.csrfToken(),
        Accept: 'application/json',
      },
      body: formData,
      credentials: 'same-origin',
    }).then((response) => {
      if (!response.ok) {
        // 失敗したら UI をロールバック
        checkbox.checked = !checkbox.checked
        console.error(`[duty-roster-toggle] 更新に失敗しました（${response.status}）`)
        window.alert('更新に失敗しました。再度お試しください。')
      }
    }).catch((err) => {
      checkbox.checked = !checkbox.checked
      console.error('[duty-roster-toggle] network error', err)
      window.alert('通信エラーが発生しました。')
    })
  }

  csrfToken () {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute('content') : ''
  }
}
